import { ElMessage } from "element-plus";
import { mapFormaPago, mapIdCia, mapPaquete } from "@/utils/emissionMappers";
import {
  fetchQuotePdfBlob,
  triggerBlobDownload,
} from "@/services/quotePdfService";
import type { EmissionSubmitDependencies } from "./contracts";
import { maintainExpandMode } from "./helpers";

export async function executeDownloadOffer(
  deps: EmissionSubmitDependencies,
): Promise<void> {
  const props = deps.getProps();
  const idCotizacion = props.quotesResponse?.Cobertura?.Id_Cotizacion;
  if (!idCotizacion) {
    ElMessage.warning("No se puede descargar: ID de cotización no disponible");
    return;
  }

  deps.state.isDownloadingOffer.value = true;
  try {
    const formaPago = mapFormaPago(props.selectedPaymentMethod);
    const paquete = mapPaquete(props.selectedPlanType);
    const idCia = mapIdCia(props.selectedCompany);
    const blob = await fetchQuotePdfBlob({
      idCotizacion,
      formaPago,
      paquete,
      cia: idCia,
    });

    triggerBlobDownload(blob, `Cotizacion-${idCotizacion}.pdf`);
    ElMessage.success("PDF descargado correctamente");
  } catch (error) {
    ElMessage.error(
      error instanceof Error ? error.message : "Error al descargar el PDF",
    );
  } finally {
    deps.state.isDownloadingOffer.value = false;
    maintainExpandMode();
  }
}

export async function executeSendOffer(
  deps: EmissionSubmitDependencies,
): Promise<void> {
  const props = deps.getProps();
  const idCotizacion = props.quotesResponse?.Cobertura?.Id_Cotizacion;
  if (!idCotizacion) {
    ElMessage.warning("No se puede enviar: ID de cotización no disponible");
    return;
  }

  const email = deps.quoteStore.quoteData.personalData?.email;
  if (!email) {
    ElMessage.warning("No se encontró el email del cliente");
    return;
  }

  deps.state.isSendingOffer.value = true;
  try {
    const quote = deps.quoteStore.quoteData;
    const result = await deps.sendQuoteEmail({
      idCotizacion: Number(idCotizacion),
      email,
      telefono: quote.personalData?.whatsapp,
      nombre: quote.personalData?.fullName,
      prima: props.quotesResponse?.Cobertura?.PrimaTotal ?? 0,
      fechaVigencia:
        quote.cotizacionData?.finVigencia ??
        quote.cotizacionData?.inicioVigencia,
      quoteData: quote,
    });

    if (!result.success) {
      ElMessage.error(result.error || "Error al enviar el email");
      return;
    }

    ElMessage.success("Cotización enviada por correo electrónico");
  } catch (error) {
    ElMessage.error(
      error instanceof Error ? error.message : "Error desconocido al enviar email",
    );
  } finally {
    deps.state.isSendingOffer.value = false;
    maintainExpandMode();
  }
}
